import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

/** "15 mai 2026" */
export const formatDateFR = (iso: string | Date): string => {
  const d = typeof iso === 'string' ? parseISO(iso) : iso;
  return format(d, 'd MMMM yyyy', { locale: fr });
};

/** "15/05/2026" — format court */
export const formatDateShort = (iso: string | Date): string => {
  const d = typeof iso === 'string' ? parseISO(iso) : iso;
  return format(d, 'dd/MM/yyyy');
};

/** "15/05/2026 14:32" */
export const formatDateTimeShort = (iso: string | Date): string => {
  const d = typeof iso === 'string' ? parseISO(iso) : iso;
  return format(d, 'dd/MM/yyyy HH:mm');
};

/** "2026-05" depuis un Date — utilisé pour les paramètres période API */
export const formatPeriode = (date: Date = new Date()): string =>
  format(date, 'yyyy-MM');
